export default "__VITE_ASSET__D1Ddql4r__"